import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from "../../environments/environment";
import { BBResponseContainer } from '../carrier/response-container';
import { timeout, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class APGMachineStatusService {
    constructor(private http: HttpClient) {
    }

    getMachineStatus(labId: string, machineType: string, manufacturer: string): Observable<BBResponseContainer> {
        let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "apg/machine/status/" + labId + "/" + machineType + "/" + manufacturer;
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
          error.url = url;
        }));
      }
}